<template>
  <b-container fluid class="customer-orders-page">
    <b-row class="overflow-auto">
      <b-table
        hover
        no-local-sorting
        small
        :fields="fields"
        :items="data"
        :busy="busy"
      >
        <template #cell(created_at)="row">
          {{ row.item.created_at | millasToSql | formatDateTime }}
        </template>
        <template #cell(user)="row">
          <template v-if="row.item.user">
            {{ row.item.user.first_name }} {{ row.item.user.last_name }}
          </template>
        </template>
        <template #cell(type)="row">
          {{ getChangedToField(row.item.changed_to, 'type', 'Edited') }}
        </template>
        <template #cell(status)="row">
          {{ getChangedToField(row.item.changed_to, 'status') | statusFormat }}
        </template>
        <template #cell(fulfillment_type)="row">
          {{ getChangedToField(row.item.changed_to, 'fulfillment_type') }}
        </template>
        <template #cell(address)="row">
          <template v-if="getChangedToField(row.item.changed_to, 'address')">
            {{
              getChangedToField(row.item.changed_to, 'address')
                | formatAddressStreet
            }}
          </template>
        </template>
        <template #cell(notes)="row">
          {{ getChangedToField(row.item.changed_to, 'notes') }}
        </template>
        <template #cell(fulfillment_time)="row">
          <template
            v-if="getChangedToField(row.item.changed_to, 'fulfillment_time')"
          >
            {{
              getChangedToField(row.item.changed_to, 'fulfillment_time')
                | formatDateTime
            }}
          </template>
        </template>
      </b-table>
      <b-pagination
        v-if="rows > perPage"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        @input="onPaginate"
      />
    </b-row>
  </b-container>
</template>

<script>
import ResourceAPI from '../../services/ResourceAPI';

export default {
  name: 'CustomerOrderHistory',
  props: {
    order: {
      type: Object,
      default() {
        return { id: null };
      },
    },
    orderPlaced: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'created_at',
          label: 'Transaction Time',
        },
        {
          key: 'user',
          label: 'User',
        },
        {
          key: 'type',
          label: 'Type',
        },
        {
          key: 'status',
          label: 'Status',
        },
        {
          key: 'address',
          label: 'Address',
        },
        {
          key: 'fulfillment_type',
          label: 'Fulfillment Method',
        },
        {
          key: 'fulfillment_time',
          label: 'Fulfillment Time',
        },
        {
          key: 'notes',
          label: 'Notes',
        },
      ],
      data: [],
      loading: false,
      currentPage: 1,
      perPage: 25,
      rows: 0,
      busy: true,
    };
  },
  watch: {
    orderPlaced: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadResults();
        }
      },
    },
  },
  methods: {
    getChangedToField(data, field, defaultVal) {
      if (data[field] !== undefined) {
        return data[field];
      }
      if (defaultVal !== undefined) {
        return defaultVal;
      }
      return null;
    },

    loadResults() {
      const me = this;

      me.busy = true;

      return ResourceAPI.getRecords('model-updates', {
        limit: me.perPage,
        page: me.currentPage,
        q: me.search,
        with: 'user',
        context: 'network-order',
        contextId: me.order.id,
        sort: 'created_at',
        dir: 'asc',
      })
        .then((data) => {
          me.rows = data.total + 1;

          // Add changed from values as first field
          const firstRow = {
            created_at: me.order.placed,
            changed_to: {
              type: 'Placed',
            },
          };

          if (data.data.length) {
            firstRow.changed_to.address = me.getChangedToField(
              me.getChangedFromData(data.data, 'address'),
              'address',
              me.order.address
            );
            firstRow.changed_to.fulfillment_time = me.getChangedToField(
              me.getChangedFromData(data.data, 'fulfillment_time'),
              'fulfillment_time',
              me.order.fulfillment_time
            );
            firstRow.changed_to.fulfillment_type = me.getChangedToField(
              me.getChangedFromData(data.data, 'fulfillment_type'),
              'fulfillment_type',
              me.order.fulfillment_type
            );
            firstRow.changed_to.notes = me.getChangedToField(
              me.getChangedFromData(data.data, 'notes'),
              'notes',
              me.order.notes
            );
          }

          me.data = [firstRow];

          me.data = me.data.concat(data.data);
          me.busy = false;
        })
        .catch((error) => console.log(error));
    },

    // Find the earliest changed from data field in the available history records
    getChangedFromData(data, field) {
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].changed_from[field] !== undefined) {
          return data[i].changed_from;
        }
      }
      return data[0].changed_from;
    },
  },
};
</script>
